import { ref } from '@vue/runtime-dom'

// 离职状态
export enum status {
  正常 = 1,
  离职 = 1,
  报废 = 3
}

// 设备类型
export enum deviceTypeEnum {
  '物理设备' = 1,
  '虚拟设备' = 2
}

export const getTableConfig = () => {
  // table 通用属性
  const common = {
    // table 有多选时设置
    isSelection: false,
    // table loading
    loading: false,
    // table 是否为斑马纹
    stripe: true,
    // table 的高度
    height: null,
    // table 的尺寸 medium / small / mini
    size: 'small',
    // table 是否开启索引
    isIndex: true,
    // table 索引 label
    indexLabel: '序号',
    // table 工具设置选项 配置则默认开启
    // tool: {
    //   // 列表本地储存name
    //   columnStorageName: 'driver-depot'
    // },
    // table 数据
    data: []
  }

  // table 分页
  const pagination = {
    // 是否展示分页
    isShow: true,
    // 总条数
    total: 0,
    // 每页显示条目个数
    pageSize: 20,
    // 当前页数
    currentPage: 1,
    // 每页显示个数选择器的选项设置
    pageSizes: [10, 20, 40, 80, 100]
  }

  // table 列数据
  const column = [
    {
      key: 'companyName',
      label: '企业名称',
      width: '140'
    },
    {
      key: 'name',
      label: '名称',
      width: '140'
    },
    {
      key: 'deviceNo',
      label: '客户端ID',
      width: '140'
    },
    {
      key: 'lastHeartbeat',
      label: '心跳时间',
      width: '140'
    },
    {
      key: 'lastOtaHeartbeat',
      label: 'ota心跳时间',
      width: '140'
    },
    {
      key: 'status',
      label: '状态',
      slot: 'status',
      width: '140'
    },
    {
      key: 'createTime',
      label: '创建时间',
      width: '140'
    },
    {
      key: 'province',
      label: '省份',
      width: '120'
    },
    {
      key: 'deviceType',
      label: '设备类型',
      width: '120',
      formatter: (row: any) => {
        return deviceTypeEnum[row.deviceType] || '-'
      }
    },
    {
      key: 'ipAddress',
      label: 'ip地址',
      width: '140'
    },
    {
      key: 'maxSessionCount',
      label: '最大会话数',
      width: '140'
    },
    {
      key: 'sessionCount',
      label: '活跃会话数',
      width: '140'
    },
    {
      key: 'action',
      label: '操作',
      width: '120',
      fixed: 'right',
      slot: 'action'
    }
  ]

  return {
    ...common,
    pagination,
    column
  }
}

// 搜索配置
export const inputList = (remoteData1: any, remoteData2: any) => [
  {
    type: 'select',
    label: '企业名称',
    key: 'companyUuid',
    placeholder: '请输入',
    labelWidth: 100,
    inputWidth: 340,
    maxlength: 50,
    options: remoteData1.options,
    isLoading: remoteData1.isLoading,
    isRemote: true,
    isMultiple: false,
    isFilterable: true,
    isCollapseTags: false,
    remoteMethod: remoteData1.remoteMethod,
    rules: {
    }
  },
  {
    type: 'input',
    label: '名称',
    key: 'name',
    placeholder: '请输入',
    labelWidth: 100,
    inputWidth: 200
  },
  {
    type: 'input',
    label: '客户端ID',
    key: 'deviceNo',
    placeholder: '请输入',
    labelWidth: 100,
    inputWidth: 200
  },
  {
    type: 'select',
    label: '状态',
    key: 'status',
    placeholder: '请选择',
    labelWidth: 100,
    inputWidth: 200,
    options: [
      {
        label: '正常',
        value: 1
      },
      {
        label: '禁用',
        value: 2
      },
      {
        label: '报废',
        value: 3
      }
    ]
  },
  {
    type: 'select',
    label: '省份',
    key: 'province',
    placeholder: '请选择',
    labelWidth: 100,
    inputWidth: 200,
    options: remoteData2.options,
    isLoading: remoteData2.isLoading,
    isMultiple: false,
    isFilterable: false,
    isCollapseTags: false,
  },
  {
    type: 'select',
    label: '设备类型',
    key: 'deviceType',
    placeholder: '请选择',
    labelWidth: 100,
    inputWidth: 200,
    options: [
      {
        label: '物理设备',
        value: 1
      },
      {
        label: '虚拟设备',
        value: 2
      }
    ]
  },
  {
    type: 'datePicker',
    dateType: 'datetime',
    label: '心跳时间开始',
    key: 'lastHeartbeatStart',
    placeholder: '开始日期',
    format: 'YYYY-MM-DD HH:mm',
    valueFormat: 'YYYY-MM-DD HH:mm:00',
    itemShow: true,
    labelWidth: 140,
    inputWidth: 200,
    isArea: true
  },
  {
    type: 'datePicker',
    dateType: 'datetime',
    label: '心跳时间结束',
    key: 'lastHeartbeatEnd',
    placeholder: '结束日期',
    format: 'YYYY-MM-DD HH:mm',
    valueFormat: 'YYYY-MM-DD HH:mm:59',
    itemShow: true,
    labelWidth: 100,
    inputWidth: 200,
    isArea: true
  }
]

// 页面搜索和基础变量
export const getIndexConfig = () => {
  // 页面基础变量
  const page = {
    queryForm: ref<any>({}), // 搜索参数
    visible: false,
    rowData: null,
    determine: false,
    title: ''
  }
  return {
    ...page
  }
}

export const getTableConfig1 = () => {
  // table 通用属性
  const common = {
    // table 有多选时设置
    isSelection: false,
    // table loading
    loading: false,
    // table 是否为斑马纹
    stripe: true,
    // table 的高度
    height: null,
    tool: null,
    // table 的尺寸 medium / small / mini
    size: 'small',
    // table 是否开启索引
    isIndex: false,
    // table 索引 label
    indexLabel: '序号',
    // table 数据
    data: []
  }

  // table 分页
  const pagination = {
    // 是否展示分页
    isShow: false,
    // 总条数
    total: 0,
    // 每页显示条目个数
    pageSize: 20,
    // 当前页数
    currentPage: 1,
    // 每页显示个数选择器的选项设置
    pageSizes: [10, 20, 40, 80, 100]
  }

  // table 列数据
  const column = [
    {
      key: 'orgName',
      label: '单位名称',
      width: '140'
    },
    {
      key: 'orgCertCode',
      label: '单位证书编号',
      width: '140'
    },
    {
      key: 'username',
      label: '账号',
      width: '140'
    },
    {
      key: 'active',
      label: '是否登录',
      width: '140',
      slot: 'active'
    },
    {
      key: 'accreditStatus',
      label: '授权状态',
      width: '140',
      slot: 'accreditStatus'
    },
    {
      key: 'lastHeartbeat',
      label: '上一次心跳时间',
      width: '140'
    },
    {
      key: 'lastContractTime',
      label: '上一次合同办理',
      width: '140'
    },
    {
      key: 'lastViolationTime',
      label: '上一次数据同步',
      width: '140'
    },
    {
      key: 'contractDuration',
      label: '合同办理耗时',
      width: '140'
    },
    {
      key: 'violationDuration',
      label: '数据同步耗时',
      width: '140'
    }
  ]

  return {
    ...common,
    pagination,
    column
  }
}
